import { useTypedSelector } from 'lib/centralStore';
import { useCallback, useMemo } from 'react';
import {
  handlerscommessaKey,
  retrieveActionTypes,
  retrieveNewCheckboxStates,
} from './components/virtualFaiLaTuaGiocata/utils/functions';
import { selectSlug } from './selectors';
import { CheckboxState, Corridore } from './types';

export const findIframeVideoByValue = (list: Array<string>, value: string): string | undefined => {
  return list.find((item) => item.includes(value));
};

// TODO TRANSFORM IN FUNCTION
export const useIsStartedEvent = (now: Date) => {
  const isStartedEvent = useCallback(
    (currentTime: string) => {
      if (now?.getTime() >= new Date(currentTime).getTime()) {
        return true;
      }
      return false;
    },
    [now]
  );
  return isStartedEvent;
};
// TODO TRANSFORM IN FUNCTION
export const useIsClosedEvent = (now: Date) => {
  return useCallback(
    (currentTime: string) => {
      if (now?.getTime() >= new Date(currentTime).getTime() + 180000) {
        return true;
      }
      return false;
    },
    [now]
  );
};

export type StateFaiLaTuaGiocataType = {
  accoppiataInOrdineStates: Array<Array<CheckboxState>>;
  trioInOrdineStates: Array<Array<CheckboxState>>;
  accoppiataInDisordineStates: Array<CheckboxState>;
  trioInDisordineStates: Array<CheckboxState>;
  accoppiataInOrdineDisabled: boolean;
  trioInOrdineDisabled: boolean;
  accoppiataInDisordineDisabled: boolean;
  trioInDisordineDisabled: boolean;
  combinationAccoppiataInOrdine: Array<Corridore>;
  combinationTrioInOrdine: Array<Corridore>;
  combinationAccoppiataInDisordine: Array<Corridore>;
  combinationTrioInDisordine: Array<Corridore>;
  scommessaKey: string;
};

// stato iniziale fai la tua giocata
export const initialStateFaiLaTuaGiocata: StateFaiLaTuaGiocataType = {
  accoppiataInOrdineStates: [],
  trioInOrdineStates: [],
  accoppiataInDisordineStates: [],
  trioInDisordineStates: [],
  accoppiataInOrdineDisabled: false,
  trioInOrdineDisabled: false,
  accoppiataInDisordineDisabled: false,
  trioInDisordineDisabled: false,
  combinationAccoppiataInOrdine: [],
  combinationTrioInOrdine: [],
  combinationAccoppiataInDisordine: [],
  combinationTrioInDisordine: [],
  scommessaKey: '',
};

// reducer FAI LA TUA GIOCATA
export const reducerFaiLaTuaGiocata = (state: StateFaiLaTuaGiocataType, action) => {
  let newState = { ...state };
  switch (action.type) {
    /**
     * SET
     */
    // ordine
    case retrieveActionTypes().SET_SCOMMESSA_IN_ORDINE_STATES:
      if (action.payload.list) {
        newState[action.payload.key] = action.payload.list.map((list) =>
          list.map((_) => ({ checked: false, disabled: false }))
        );
        return newState;
      } else {
        return newState;
      }
    // disordine
    case retrieveActionTypes().SET_SCOMMESSA_IN_DISORDINE_STATES:
      newState[action.payload.key] = action.payload.list.map((_) => ({ checked: false }));
      return newState;

    case retrieveActionTypes().SET_KEY_SCOMMESSA:
      newState.scommessaKey = handlerscommessaKey(action.payload.list, action.payload.combinationType);
      return newState;
    // disabled
    case retrieveActionTypes().SET_SCOMMESSA_DISABLE:
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };

    /**
     * UPDATE
     */
    case retrieveActionTypes().UPDATE_SCOMMESSA_IN_ORDINE_STATES:
      newState[action.payload.key] = retrieveNewCheckboxStates({
        state: newState[action.payload.key]!,
        indexRowSelected: action.payload.item.indexRowSelected,
        indexButtonSelected: action.payload.item.indexButtonSelected,
        checked: action.payload.item.checked,
        disabled: action.payload.item.disabled,
      });
      return newState;

    case retrieveActionTypes().UPDATE_SCOMMESSA_IN_DISORDINE_STATES:
      newState[action.payload.key] = newState[action.payload.key].map((value, indexValue) => {
        if (action.payload.item.index === indexValue) {
          return { ...value, checked: action.payload.item.checked };
        }
        return { ...value };
      });
      return newState;

    case retrieveActionTypes().UPDATE_SCOMMESSA_IN_ORDINE_COMBINATION:
      newState[action.payload.key] = [...newState[action.payload.key], action.payload.item];
      return newState;

    case retrieveActionTypes().UPDATE_SCOMMESSA_IN_DISORDINE_COMBINATION:
      newState[action.payload.key] = [...newState[action.payload.key], action.payload.item];
      return newState;
    /**
     * FILTER
     */

    case retrieveActionTypes().FILTER_SCOMMESSA_COMBINATION:
      newState[action.payload.key] = newState[action.payload.key].filter((item) => item?.id !== action.payload.id);
      return newState;

    /**
     * RESET
     */
    case retrieveActionTypes().RESET_SCOMMESSA_IN_ORDINE_STATES:
      newState[action.payload.key] = newState[action.payload.key].map((list) => {
        return list.map((_) => {
          return {
            checked: false,
            disabled: false,
          };
        });
      });
      return newState;

    case retrieveActionTypes().RESET_SCOMMESSA_IN_DISORDINE_STATES:
      newState[action.payload.key] = newState[action.payload.key].map((_) => {
        return {
          checked: false,
          disabled: false,
        };
      });
      return newState;
    case retrieveActionTypes().RESET_SCOMMESSA_COMBINATION:
      newState[action.payload.key] = [];
      return newState;
    case retrieveActionTypes().RESET_KEY_SCOMMESSA:
      newState['scommessaKey'] = initialStateFaiLaTuaGiocata.scommessaKey;
      return newState;
    default:
      throw new Error(`${action.type} - errore`);
  }
};

export const useIsAvvenimento = () => {
  const slug = useTypedSelector(selectSlug);
  const isAvvenimento = useMemo(() => {
    const [_basePath, ...fragments] = slug?.split('/');
    return fragments.length >= 3;
  }, [slug]);
  return isAvvenimento;
};
